


//     Eteration UI 1.0
//     (c) 2014 Eteration A.S.
//     http://eteration.com




define('eteration/widgets/ui-spinner',['jquery', 
        'knockout',
		'eteration/eteration-i18n',
        'eteration/widgets/widget-util',
        ], function($, ko,i18n,widgetUtil){

	ko.bindingHandlers['spinner'] = {
			init : function(element, valueAccessor, allBindings) {
		        var el = $(element);
		        var counter = valueAccessor().value;
		        
		        var continueInc = valueAccessor().continueInc;
		   
		        
		        
		        el.focus(function () {
		        	el.blur();
		        });
		        
		        el.bind("keydown", function (event) {
		            event.preventDefault()
		        });
		        
		        el.val(counter());
		        
		        el.spinner({
		    		min: 0,
		    		max: 50,
		    		numberFormat: "n",
		    		page: 0,
		    		create: function(event, ui){
		    			$(this).attr('readonly', 'readonly');
		    			if(counter()>0)
		    				$(this).closest('.ui-spinner').addClass('active');
		    		},
		    		spin: function(event, ui){
		    			$(this).parents('.ui-spinner').addClass('active');
		    			if ( ui.value === 0 )
		    				$(this).parents('.ui-spinner').removeClass('active');
		    			
		    			if(continueInc!=undefined && !continueInc() && event.currentTarget.className!='ui-spinner-button ui-spinner-down ui-corner-br'){
		    				if( counter() == 0 ) {
		    					$(this).parents('.ui-spinner').removeClass('active');
		    				}
		    				event.preventDefault();
		    				return false;
				    	}
		    			
		    		}
		    	});
		        
		        
		     
		       el.next().on("click", function(e){
		    	   if(continueInc==undefined){
		    		   counter(counter()+1); 
		    	   }else if(continueInc()){
		    		   counter(counter()+1); 
		    	   }else if(!continueInc()){
		    		   e.preventDefault();
		    	   }
		        });
		       
		        el.next().next().on("click", function(e){
		    	    var nc = counter()-1;
		            if(nc< 0)
		    			   nc=0;
		    		counter(nc);
		        });
		       
			}
		};
	
	
	ko.bindingHandlers['spinnerForAvalaibility'] = {
			init : function(element, valueAccessor, allBindings) {
		        var el = $(element);
		        var counter = valueAccessor().value;
		        
		        var continueInc = valueAccessor().continueInc;

		        var maxAdult = valueAccessor().max || 9;
		        
		        el.focus(function () {
		        	el.blur();
		        });
		        
		        el.bind("keydown", function (event) {
		            event.preventDefault()
		        });
		        
		        el.val(counter());
		        
		        el.spinner({
		    		min: 0,
		    		max: 9,
		    		numberFormat: "n",
		    		page: 0,
		    		create: function(event, ui){
		    			$(this).attr('readonly', 'readonly');
		    			if(counter()>0)
		    				$(this).closest('.ui-spinner').addClass('active');
		    		},
		    		spin: function(event, ui){
		    			$(this).parents('.ui-spinner').addClass('active');
		    			if ( ui.value === 0 )
		    				$(this).parents('.ui-spinner').removeClass('active');	
		    			if ( ui.value === 9 )
			    				$(this).parents('.ui-spinner').removeClass('active');
		    			
		    			if(continueInc!=undefined && !continueInc()){
		    				event.preventDefault();
		    				return false;
				    	}
		    			
		    		}
		    	});
		        
		        
		     
		       el.next().on("click", function(e){
		    	   if(continueInc==undefined){
		    		   counter(counter()+1); 
		    	   }else if(continueInc()){
		    		   counter(counter()+1); 
		    	   }else if(!continueInc()){
		    		   e.preventDefault();
		    	   }
		        });
		       
		        el.next().next().on("click", function(e){
		        	var nc = counter()-1;
		            if(nc< 0)
		    			   nc=0;
		            if(nc> 9)
		    			   nc=9;
		            
		            
		    		counter(nc);
		        });
		       
			}
		};

	
	ko.bindingHandlers['spinnerForAddBaby'] = {
			init : function(element, valueAccessor, allBindings) {
		        var el = $(element);
		        var counter = valueAccessor().value;
		        var nextClickFunction = valueAccessor().nextClickFunction;
		        var previousClickFunction = valueAccessor().previousClickFunction;
		        var maxValue = valueAccessor().maxValue;
		        
		        el.focus(function () {
		        	el.blur();
		        });
		        
		        el.bind("keydown", function (event) {
		            event.preventDefault()
		        });
		        
		        el.val(counter());
		        el.spinner({
		    		min: 1,
		    		max: maxValue,
		    		numberFormat: "n",
		    		page: 0,
		    		create: function(event, ui){
		    			$(this).attr('readonly', 'readonly');
		    			if(counter()>0)
		    				$(this).closest('.ui-spinner').addClass('active');

						var $spinner = $(this).closest('.ui-spinner');
						var $plusBtn = $spinner.find('.ui-spinner-up');
						var $minusBtn = $spinner.find('.ui-spinner-down');

						$plusBtn.attr({
							'aria-label': i18n.get('increaseInfantCount'),
							'role': 'button'
						});

						$minusBtn.attr({
							'aria-label': i18n.get('decreaseInfantCount'),
							'role': 'button'
						});
		    		},
		    		spin: function(event, ui){
		    			$(this).parents('.ui-spinner').addClass('active');
		    			if ( ui.value === 0 )
		    				$(this).parents('.ui-spinner').removeClass('active');
		    		}
		    	});
		        
		        
		     
		       el.next().on("click", function(e){
		    	   
		    	   if(counter()==0){
		    		   counter(1);
		    	   }
		    	   
		    	   if(counter()<maxValue){
		    		   counter(counter()+1); 
		    		   nextClickFunction();
		    	   }
		    	   else if(counter()>maxValue)
		    	   {
		    		   
		    	   }
		        });
		       
		        el.next().next().on("click", function(e){
		        	
		    	    var nc = counter()-1;
		            if(nc< 0)
		    			   nc=0;
		    		counter(nc);
		    		
		    		previousClickFunction();
		        });
		       
			}
		};
		//Added by Sobia Javed: Defect 2871
			ko.bindingHandlers['spinnerForInsurance'] = {
					init : function(element, valueAccessor, allBindings) {
				        var el = $(element);
				        var counter = valueAccessor().value,
				        lastValue = el.val() || 0;
				        
				        var maxPersonAlloved = valueAccessor().maxPersonAlloved,
				        totalPaxCount = valueAccessor().totalPaxCount;
				        
				        
				        
				        el.focus(function () {
				        	el.blur();
				        });
				        
				        el.bind("keydown", function (event) {
				            event.preventDefault()
				        });
				        
				        el.val(counter());
				        
				        el.spinner({
				    		min: 0,
				    		max: 20,
				    		value:counter() || 0,
				    		numberFormat: "n",
				    		create: function(event, ui){
				    			$(this).attr('readonly', 'readonly');
				    			if(counter()>0)
				    				$(this).closest('.ui-spinner').addClass('active');
				    		},
				    		start: function(event, ui){
				    			if ( ui.value === 0 )
				    				$(this).parents('.ui-spinner').removeClass('active');
				    			if(totalPaxCount!=undefined && maxPersonAlloved!=undefined){
				    				if((($(event.currentTarget).is('.ui-spinner-up') && totalPaxCount() >= maxPersonAlloved())
				    						|| (($(event.currentTarget).is('.ui-spinner-down') && totalPaxCount() <= 1)))){
				    					event.preventDefault();
					    				event.stopPropagation();
					    				return false;
							    	}
				    				
						    	}
				    		},
				    		stop:function(event, ui){
				    			counter(parseInt(el.val()))
				    			lastValue = el.val();
				    			if(lastValue == 0 ) {
			    					$(this).parents('.ui-spinner').removeClass('active');
			    				}else{
			    					$(this).parents('.ui-spinner').addClass('active');
			    				}
				    			

				    		}
				    		
				    	});
					}
				};

				ko.bindingHandlers['spinnerForCarrent'] = {
					init : function(element, valueAccessor, allBindings) {
				        var el = $(element);
				        var counter = valueAccessor().value,
				        lastValue = el.val() || 0;
				        
				        var maxPersonAlloved = valueAccessor().maxPersonAlloved,
				        totalPaxCount = valueAccessor().totalPaxCount;
				        
				        el.focus(function () {
				        	el.blur();
				        });
				        
				        el.bind("keydown", function (event) {
				            event.preventDefault()
				        });
				        
				        el.val(counter());
				        
				        el.spinner({
				    		min: 18,
				    		max: 75,
				    		value:counter() || 0,
				    		numberFormat: "n",
				    		create: function(event, ui){
				    			$(this).attr('readonly', 'readonly');
				    			if(counter() > 0){
				    				$(this).closest('.ui-spinner').addClass('active');
				    			}
				    		},
				    		start: function(event, ui){
				    			if ( ui.value === 0 )
				    				$(this).parents('.ui-spinner').removeClass('active');
				    	
				    		},
				    		stop:function(event, ui){
				    			counter(parseInt(el.val()))
				    			lastValue = el.val();
				    			if(lastValue == 0 ) {
			    					$(this).parents('.ui-spinner').removeClass('active');
			    				}else{
			    					$(this).parents('.ui-spinner').addClass('active');
			    				}
				    			

				    		}
				    		
				    	});
					}
				};
	
		ko.bindingHandlers['customSpinnerForAdult'] = {
			init : function(element, valueAccessor, allBindings) {
		        var el = $(element);
		        var accessor = valueAccessor();
		        var decreaseText = accessor.decreaseText;
		        var increaseText = accessor.increaseText;
		        var counter = accessor.value;
		        
		        var upperText = function(){
		        	return increaseText + " " + (counter() + 1).toString();
		        }
		        
		        var lowerText = function(){
		        	return decreaseText + " " + (counter() - 1).toString();
		        }
		        
		        var updateSpinnerTexts = function(){
		        	el.parent().find("span[name='upperCount']").text(upperText());
			    	el.parent().find("span[name='lowerCount']").text(lowerText());
		       }
		        
		        $.widget("ui.spinner", $.ui.spinner, {
		    		_buttonHtml: function() {
		    			return "" +
		    			"<a name='lowerCountSpinner' class='ui-spinner-button ui-spinner-down ui-corner-br' tabindex='0' role='button'>" +
		    				"<span name='lowerCount' class='ui-icon " + this.options.icons.down + "'>"+ lowerText() + "</span>" +
		    			"</a>" + 
		    			"<a name='upperCountSpinner' class='ui-spinner-button ui-spinner-up ui-corner-tr' tabindex='0' role='button'>" +
							"<span name='upperCount' class='ui-icon " + this.options.icons.up + "'>" + upperText() +"</span>" +
						"</a>";
		    	    }
		    	});
		        
		        var minValue = 0;
		        var maxValue =  9; 
		        var max= ko.unwrap(accessor.maxValue);
		        if(max || max==0){
		        	maxValue = max;
		        }
		        
		        
		        el.focus(function () {
		        	el.blur();
		        });
		        
		        el.bind("keydown", function (event) {
		            event.preventDefault()
		        });
		        
		        el.val(counter());
		        el.spinner({
		    		min: minValue,
		    		max: maxValue,
		    		numberFormat: "n",
		    		page: 0,
		    		create: function(event, ui){
		    			$(this).attr('readonly', 'readonly');
		    			if(counter()>0)
		    				$(this).closest('.ui-spinner').addClass('active');
		    		},
		    		spin: function(event, ui){
		    			$(this).parents('.ui-spinner').addClass('active');
		    			if ( ui.value === 0 )
		    				$(this).parents('.ui-spinner').removeClass('active');
		    		}
		    	});
		        
		        el.parent().find("a[name='upperCountSpinner']").on('keyup', function(e){
		        	e.preventDefault();
		        	if (e.which === 13 || e.keyCode === 13) {
		                el.val(counter());
		                
		                if (counter()>=maxValue){
		    			   $(this).addClass('ui-spinner-button-up-not-active');
		                }
		                
		                var parentEl = $(this).parent();
		                if(counter()>minValue && !parentEl.hasClass("active")){
		                	parentEl.addClass("active");
		                }
		            }
		        });
		        
		        el.parent().find("a[name='lowerCountSpinner']").on('keyup', function(e){
		        	e.preventDefault();
		        	if (e.which === 13 || e.keyCode === 13) {
		        		el.val(counter());
		        		
		        		if (upLink && (counter() < maxValue)){
		        			$(upLink).removeClass('ui-spinner-button-up-not-active');
	   		    		}
		        		
		        		var parentEl = $(this).parent();
		                if(counter()<=minValue && parentEl.hasClass("active")){
		                	parentEl.removeClass("active");
		                }
		            }
		        });
		        
		       var upLink = null;
		       el.parent().find("a[name='upperCountSpinner']").on("click", function(e){
		    	   upLink = this;
		    	   if(counter()<maxValue){
		    		   counter(counter()+1); 
		    		   
		    		   // to set cursor
		    		   if (counter()>=maxValue)
		    		   {
		    			   $(this).addClass('ui-spinner-button-up-not-active');
		    		   }
		    		  
		    	   }
		    	   
		    	   updateSpinnerTexts();
		    		   
		        });
		       
		       el.parent().find("a[name='lowerCountSpinner']").on("click", function(e){
		        	
		    	    var nc = counter()-1;
		            if(nc< 0)
		    			   nc=0;
		    		counter(nc);
		    		
		    		// to set cursor
		    		if (upLink)
		    		{
			    		   if (counter() < maxValue)
			    		   {
			    			   $(upLink).removeClass('ui-spinner-button-up-not-active');
			    		   }
   		    		}
		    		
		    		updateSpinnerTexts();
		        });
		       
			}
		};
		
		ko.bindingHandlers['customSpinnerForAwardTicket'] = {
				init : function(element, valueAccessor, allBindings) {
			        var el = $(element);
			        var counter = valueAccessor().value;
			        var maxValue = 5;
			        
			        el.focus(function () {
			        	el.blur();
			        });
			        
			        el.bind("keydown", function (event) {
			            event.preventDefault()
			        });
			        
			        el.val(counter());
			        el.spinner({
			    		min: 0,
			    		max: maxValue,
			    		numberFormat: "n",
			    		page: 0,
			    		create: function(event, ui){
			    			$(this).attr('readonly', 'readonly');
			    			if(counter()>0)
			    				$(this).closest('.ui-spinner').addClass('active');
			    		},
			    		spin: function(event, ui){
			    			$(this).parents('.ui-spinner').addClass('active');
			    			if ( ui.value === 0 )
			    				$(this).parents('.ui-spinner').removeClass('active');
			    		}
			    	});
			        
			        
			       var upLink = null;
			       el.next().on("click", function(e){
			    	   upLink = this;
			    	   if(counter()<maxValue){
			    		   counter(counter()+1); 
			    		   
			    		   // to set cursor
			    		   if (counter()>=maxValue)
			    		   {
			    			   $(this).addClass('ui-spinner-button-up-not-active');
			    		   }
			    		  
			    	   }
			    	  
			    		   
			        });
			       
			        el.next().next().on("click", function(e){
			        	
			    	    var nc = counter()-1;
			            if(nc< 0)
			    			   nc=0;
			    		counter(nc);
			    		
			    		// to set cursor
			    		if (upLink)
			    		{
				    		   if (counter() < maxValue)
				    		   {
				    			   $(upLink).removeClass('ui-spinner-button-up-not-active');
				    		   }
	   		    		}
			    		
			        });
			       
				}
			};
		
			ko.bindingHandlers['spinnerForEvisa'] = {
					init : function(element, valueAccessor, allBindings) {
				        var el = $(element);
				        var counter = valueAccessor().value,
				        lastValue = el.val() || 0;
				        
				        var maxPersonAlloved = valueAccessor().maxPersonAlloved,
				        totalPaxCount = valueAccessor().totalPaxCount;
				        
				        el.focus(function () {
				        	el.blur();
				        });
				        
				        el.bind("keydown", function (event) {
				            event.preventDefault()
				        });
				        
				        el.val(counter());
				        
				        el.spinner({
				    		min: 0,
				    		max: 20,
				    		value:counter() || 0,
				    		numberFormat: "n",
				    		create: function(event, ui){
				    			$(this).attr('readonly', 'readonly');
				    			if(counter()>0)
				    				$(this).closest('.ui-spinner').addClass('active');
				    		},
				    		start: function(event, ui){
				    			if ( ui.value === 0 )
				    				$(this).parents('.ui-spinner').removeClass('active');
				    			if(totalPaxCount!=undefined && maxPersonAlloved!=undefined){
				    				if((($(event.currentTarget).is('.ui-spinner-up') && totalPaxCount() >= maxPersonAlloved())
				    						|| (($(event.currentTarget).is('.ui-spinner-down') && totalPaxCount() <= 1)))){
				    					event.preventDefault();
					    				event.stopPropagation();
					    				return false;
							    	}
						    	}
				    		},
				    		stop:function(event, ui){
				    			counter(parseInt(el.val()))
				    			lastValue = el.val();
				    			if(lastValue == 0 ) {
			    					$(this).parents('.ui-spinner').removeClass('active');
			    				}else{
			    					$(this).parents('.ui-spinner').addClass('active');
			    				}
				    		}
				    	});
					}
				};		
	
		
});





